import domain from "./domain.js";
import range from "./range.js";
import align from "./align.js";
import base from "./base.js";
import clamp from "./clamp.js";
import constant from "./constant.js";
import exponent from "./exponent.js";
import interpolate from "./interpolate.js";
import nice from "./nice.js";
import padding from "./padding.js";
import reverse from "./reverse.js";
import round from "./round.js";
import unknown from "./unknown.js";
import zero from "./zero.js";
/**
 * List of all operators, in order of execution
 */
export const ALL_OPERATORS = [
// domain => nice => zero
'domain', 'nice', 'zero',
// interpolate before round
'interpolate', 'round',
// set range then reverse
'range', 'reverse',
// Order does not matter for these operators
'align', 'base', 'clamp', 'constant', 'exponent', 'padding', 'unknown'];
// Use Record to enforce that all keys in OperatorType must exist.
const operators = {
  domain,
  nice,
  zero,
  interpolate,
  round,
  align,
  base,
  clamp,
  constant,
  exponent,
  padding,
  range,
  reverse,
  unknown
};
export default function scaleOperator() {
  for (var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++) {
    ops[_key] = arguments[_key];
  }
  const selection = new Set(ops);
  const selectedOps = ALL_OPERATORS.filter(o => selection.has(o));
  return function applyOperators(scale, config) {
    if (typeof config !== 'undefined') {
      selectedOps.forEach(op => {
        operators[op](scale, config);
      });
    }
    return scale;
  };
}